module.exports = __webpack_public_path__ + "static/media/arrow-down.48aeac8e.svg";